import { config } from '../config'
import { FilmBand } from './FilmBand'

/**
 * 三条半圆柱 band：上、中、下分别有自己的 y、滚动速度、方向、模糊。
 */
export function FilmRing() {
  return (
    <group>
      {config.filmstrip.bands.map((b) => (
        <FilmBand
          key={b.id}
          band={b.id}
          y={b.y}
          scrollSpeed={b.scrollSpeed}
          scrollDirection={b.scrollDirection}
          blurPx={b.blurPx}
        />
      ))}
    </group>
  )
}
